var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ob1-popin-modal2",
    {
      attrs: { id: _vm.modalId, "aria-labelledby": _vm.modalId },
      on: {
        "ob1-popin-modal-click": function ($event) {
          return _vm.onClosePopin()
        },
      },
    },
    [
      _c("h3", {
        staticClass: "mb-1 mb-md-2",
        domProps: { innerHTML: _vm._s(_vm.labels.title) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-lg-6" }, [
          _c(
            "fieldset",
            [
              _c("legend", { staticClass: "visually-hidden" }, [
                _vm._v(
                  "\n                    Etat du mobile Reconditionné\n                "
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.labels.descriptions, function (grade, index) {
                return _c("ob1-chips", {
                  key: "popin-grade-" + index,
                  attrs: {
                    id: "popin-grade-" + index,
                    "is-choice-version": true,
                    label: grade.label,
                    "disable-uncheck": true,
                    "is-checked": _vm.selectedGrade === grade,
                    "additional-classes": "mb-1",
                  },
                  on: {
                    "ob1-chips-click": function ($event) {
                      return _vm.changeSelectedGrade(grade)
                    },
                  },
                })
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.selectedGrade.text) },
          }),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "visually-hidden",
            attrs: { href: "#grade-details-info" },
          },
          [_vm._v(_vm._s(_vm.labels.avoidanceLinkLabel))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-lg-6 mt-1 mt-lg-0" },
          [
            _c("ob1-carrousel", {
              staticClass: "mb-1",
              attrs: {
                id: "grade-details-carrousel",
                images: _vm.selectedGrade.images,
                "with-zoom": true,
              },
              on: { onZoomChange: _vm.zoomChangeHandler },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("ob1-message-alerte", {
        staticClass: "mt-lg-2",
        attrs: {
          id: "grade-details-info",
          type: "info",
          "is-simple-alerte": false,
          title: _vm.labels.message.title,
          "liste-a-puces-dto": _vm.listAPuces,
          role: "status",
        },
      }),
      _vm._v(" "),
      _c("p", {
        staticClass: "pt-0 small",
        domProps: { innerHTML: _vm._s(_vm.labels.legalMentions) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }